<template>
  <general-layout>
    <b-container>
      <b-row align-h="center">
        <b-col sm="12">
          <b-alert
            :show="isShowUnauthenticatedAlert"
            dismissible
            variant="danger"
            @dismissed="isShowUnauthenticatedAlert = false">
            {{ $t('status.error.not_log_in') }}
          </b-alert>
        </b-col>
        <b-col cols="6" lg="7">
          <div id="authcore-profile-widget"></div>
        </b-col>
      </b-row>
    </b-container>
  </general-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { AuthCoreWidgets } from 'authcore-js'

import GeneralLayout from '@/components/GeneralLayout.vue'

export default {
  name: 'Profile',
  components: {
    GeneralLayout
  },

  props: {
    isShowUnauthenticatedAlert: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      widget: undefined
    }
  },

  computed: {
    ...mapState('client', [
      'authClient'
    ]),
    ...mapGetters('client', [
      'accessToken'
    ])
  },

  watch: {
    accessToken (newVal) {
      if (newVal !== undefined) {
        this.widget.updateAccessToken(newVal)
      }
    }
  },

  created () {},
  mounted () {
    this.widget = new AuthCoreWidgets.Profile({
      clientId: 'management',
      container: 'authcore-profile-widget',
      internal: true,
      accessToken: this.authClient.getAccessToken(),
      // Handle the unauthenticated case returns from the widget
      unauthenticated: () => {
        this.authClient.config.callbacks.unauthenticated()
      }
    })
  },
  updated () {},
  destroyed () {},

  methods: {}
}
</script>

<style>
iframe {
  width: 100%;
  height: 650px;
  border: 0px;
  overflow: hidden;
}
</style>
